import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, BookOpen, BrainCircuit, Award } from "lucide-react";
import TopNav from "@/components/TopNav";

export default function Landing() {
  return (
    <div className="min-h-screen relative">
      <TopNav />
      <main className="max-w-7xl mx-auto px-6 pt-16 pb-24 relative">
        <section className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="tw-mono-label mb-5" data-testid="hero-eyebrow">TIPPS ADAMS WEB-BASED TRAINING INITIATIVE</div>
            <h1 className="tw-display font-extrabold leading-[0.95] text-5xl sm:text-6xl lg:text-7xl tracking-tighter" data-testid="hero-title">
              Manage the<br/>
              <span className="italic font-medium text-stone-700">complexity</span><br/>
              away.
            </h1>
            <p className="mt-8 text-stone-700 text-lg max-w-xl leading-relaxed">
              TAWBTI is a focused training platform built around the One-Hour MBA framework — five building blocks
              that turn complex management problems into clear, repeatable practice.
            </p>
            <div className="mt-10 flex items-center gap-4 flex-wrap">
              <Link to="/register" className="tw-btn-primary inline-flex items-center gap-2" data-testid="hero-cta-start">
                Start learning <ArrowRight size={16}/>
              </Link>
              <Link to="/login" className="tw-btn-outline" data-testid="hero-cta-signin">I already have an account</Link>
            </div>
            <div className="mt-12 flex items-center gap-6 text-sm text-stone-600">
              <div className="flex items-center gap-2"><Sparkles size={16} className="text-amber-600"/> AI tutor included</div>
              <div className="flex items-center gap-2"><Award size={16} className="text-emerald-700"/> Earn a certificate</div>
            </div>
          </div>

          <div className="lg:col-span-5 relative">
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1515378960530-7c0da6231fb1?crop=entropy&cs=srgb&fm=jpg&w=900&q=80"
                alt="learner"
                className="rounded-3xl w-full object-cover h-[440px] border border-stone-200"
              />
              <div className="absolute -left-6 -bottom-6 tw-card p-5 w-64 shadow-lg">
                <div className="tw-mono-label">CURRENT BLOCK</div>
                <div className="mt-2 font-semibold tw-display">Five Building Blocks</div>
                <div className="tw-progress-track mt-3"><div className="tw-progress-fill" style={{width:"35%", background:"var(--tawbti-blue-fill)"}}/></div>
                <div className="text-xs text-stone-500 mt-2">35% — Block 2 of 7</div>
              </div>
              <div className="absolute -right-4 top-4 tw-card p-4 w-52 shadow-lg">
                <div className="tw-mono-label">QUIZ SCORE</div>
                <div className="tw-display text-3xl font-extrabold mt-1">91<span className="text-xl text-stone-500">%</span></div>
                <div className="text-xs text-stone-500 mt-1">Block 1 — passed</div>
              </div>
            </div>
          </div>
        </section>

        <section className="mt-28 grid md:grid-cols-3 gap-6">
          {[
            {icon: BookOpen, title: "Structured curriculum", body: "Seven blocks, each with video, slides, reading, interactive exercises, and quizzes."},
            {icon: BrainCircuit, title: "Claude-powered AI tutor", body: "Ask anything mid-lesson. Get a Socratic answer grounded in your reading."},
            {icon: Award, title: "Track-able progress", body: "Block-by-block unlocking, quiz scores, and a certificate when you finish."},
          ].map(({icon:Icon,title,body},i)=>(
            <div key={i} className="tw-card p-7 tw-card-hover" data-testid={`feature-card-${i}`}>
              <Icon size={22} className="text-stone-700"/>
              <h3 className="mt-4 font-bold text-xl tw-display">{title}</h3>
              <p className="mt-2 text-stone-600 leading-relaxed">{body}</p>
            </div>
          ))}
        </section>
      </main>
    </div>
  );
}
